export const STATISTICS = {
  title: 'Как облако помогает бизнесу',
  image: 'https://cdn.cloud.ru/backend/images/about/stat_img.png',
  items: [
    { value: '30%', description: 'Средняя экономия на инфраструктуре**' },
    {
      value: '56%',
      description: 'Снижение операционных затрат в облаке за 5 лет***',
    },
    { value: '75%', description: 'Рост эффективности IT&#8209;команд***' },
  ],
  notes: [
    '**В облаке в сравнении с локальной инфраструктурой, по данным исследования облачной зрелости российского бизнеса от 2023 года.',
    '***Источник: IDC — исследование использования облака среди крупных предприятий из разных отраслей в течение пяти лет.',
  ],
};

export const ANCHOR_SERVICES = 'services';
